import { inject, Pipe, PipeTransform } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { Asset } from 'src/app/common/models/ai-reports/shared/assets';
import { ClientAssetService } from 'src/app/services/AIReports/client-asset-service';
import { ChatStore } from 'src/app/services/store';

@Pipe({ name: 'assetMeta', standalone: true, pure: true })
export class AssetMetaPipe implements PipeTransform {
  private readonly clientAssetService = inject(ClientAssetService);
  private readonly chatStore = inject(ChatStore);

  transform(id: string | null | undefined): Observable<Asset | null> {
    const threadId = this.chatStore.thread_id();
    if (!id || !threadId) return of(null);
    return this.clientAssetService.getMeta(threadId, id).pipe(
      catchError(() => of(null))
    );
  }
}
